// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3ayCN","notes":"Notes_notes__TpnNj"};